import { Segment } from "./Segment";
import { CookieStorage } from "../CookieStorage";
import { QueryStorage } from "../QueryStorage";
import quizList from "@/common/quiz";

let instance = null;

export class SegmentFactory {
  static getInstance() {
    if (!instance) throw new Error("Segment is not created");

    return instance;
  }

  static createInstance(href, router) {
    if (instance) throw new Error("Segment is already created");

    const storage = new CookieStorage();
    const queryStorage = new QueryStorage(router);
    const segment = new Segment(href, storage, quizList, queryStorage);
    instance = segment;

    return segment;
  }
}
